const HeroMobile = () => {
  return (
    <section className="w-full mt-12">
      <div className="relative aspect-square w-full overflow-hidden">
        <video
          src="https://assets.tea-n-tech.com/tea-n-tech-video-hero.mp4"
          autoPlay
          muted
          loop
          playsInline
          className="absolute inset-0 w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/40 to-black/60 flex items-center">
          <div className="w-full px-4 py-8">
            <div className="max-w-md mx-auto">
              <h1 className="text-3xl font-bold text-white mb-3 text-center">
                Tea & Tech
              </h1>
              <p className="text-base text-white/90 mb-6 text-center">
                Real talk about AI, software, and engineering. No buzzwords,
                just practical insights from the trenches.
              </p>
              <div className="flex flex-col gap-3">
                <a
                  href="#about"
                  className="bg-white text-black px-6 py-3 rounded-full font-medium hover:bg-white/90 transition-colors text-center"
                >
                  Our Story
                </a>
                <a
                  href="#contact"
                  className="border border-white text-white px-6 py-3 rounded-full font-medium hover:bg-white/10 transition-colors text-center"
                >
                  Let&apos;s Chat
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroMobile;
